module.exports = __webpack_public_path__ + "img/bishop-college-logo.8bbaf04f.jpg";